import { Injectable } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable } from 'rxjs';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Injectable()
export class PerformerConfigService {
    private lookupConfig = new ReplaySubject<any>();
    constructor(private http: HttpService) {
        // let rootPath = '';
        // try {
        //     rootPath = (window as any).gspframeworkService.common.getBasePath.get();
        // } catch (error) {
        // }
        // this.http.get(rootPath + '/platform/runtime/wf/web/wf-proc-designer/assets/config/performerlookupconfig.json').subscribe((data) => {
        this.http.get('/platform/runtime/wf/web/wf-proc-designer/assets/config/performerlookupconfig.json').subscribe((data) => {
            this.lookupConfig.next(data);
        });
    }

    getLookupConfig(): Observable<any> {
        return this.lookupConfig.asObservable();
    }
}
